import { render } from "./App.vue?vue&type=template&id=7d7faa4b"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import exportComponent from "/home/dyam/Documentos/LYRASHOES/mi-stock-lyrashoes-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__